import React, { useEffect } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { createStore } from 'stores/eventOverviewStore';
import { requestEvent } from 'actions/inPersonTraining/eventOverview';
import Loading from 'components/shared/Loading';
import {
  TabList,
  TabbedView,
  Tab,
  TabPanel,
} from 'components/shared/TabbedView';
import Header from './Header';
import AssociatedContent from './AssociatedContent';
import Attendees from './Attendees';
import EventChangeManagement from './EventChangeManagement';
import Sessions from './Sessions';
import EventOverviewSidebar from './Sidebar';

const store = createStore();

function EventOverview({ match: { params } }) {
  const { eventId } = params;
  const { sessionId } = params;
  const dispatch = useDispatch();
  const loading = useSelector(state => state.loading);
  const sessions = useSelector(state => state.sessions);
  const currentSession = useSelector(state => state.currentSession);
  const singleSession = sessions.length === 1;
  const isSessionPresent = sessions.some(
    session => Number(session.id) === Number(sessionId),
  );
  useEffect(() => {
    dispatch(requestEvent(eventId));
  }, [dispatch, eventId]);

  return (
    <Loading loading={loading}>
      <div className="PathBuilder">
        <EventChangeManagement />
        <div className="PathBuilder-main">
          <div className="PathViewer">
            {singleSession || isSessionPresent ? (
              <>
                <Header />
                <Sessions currentSessionId={sessionId} />
                <AssociatedContent />
                <Attendees currentSessionId={sessionId} />
              </>
            ) : (
              <>
                <Header currentSession={currentSession} />
                <TabbedView>
                  <TabList className="mb-24">
                    <Tab>
                      {t('in_person_training.event_overview.sessions.title')}
                    </Tab>
                    <Tab>
                      {t(
                        'in_person_training.event_overview.attendances.guests',
                      )}
                    </Tab>
                  </TabList>
                  <TabPanel>
                    <Sessions />
                  </TabPanel>
                  <TabPanel>
                    <Attendees />
                  </TabPanel>
                </TabbedView>
              </>
            )}
          </div>
        </div>
        <div className="PathBuilder-side">
          <EventOverviewSidebar sessionId={sessionId} />
        </div>
      </div>
    </Loading>
  );
}

export default props => (
  <Provider store={store}>
    <EventOverview {...props} />
  </Provider>
);
